import React, { useContext } from 'react';
import { getIntl } from '../../../../../../utils/intl';
import LargeAlertPaper from '../../../../../v2BaseComponents/LargeAlertPaper';
import { useMyOrganizationClientInvitations } from '../../../../../../hooks/api/useMyOrganizationClientInvitations';
import { RePromptOrganizationInvitationContext } from '../../../../../shared/OrganizationInvitationGate';
import getName from '../../../../../../utils/getName';

const intl = getIntl('inbound-transfer-request-alert-message', {
    header: 'Pending Professional Invitation',
    content:
        "{organizationName} has invited has requested to to collaborate with you for {profileName}'s profile. Please review this request.",
    actionText: 'Review Request',
});

export type ClientInvitationAlertOwnProps = {};

export type ClientInvitationAlertProps = ClientInvitationAlertOwnProps;

const ClientInvitationAlert: React.FC<ClientInvitationAlertProps> = () => {
    const { isLoadingClientInvitations, clientInvitations } = useMyOrganizationClientInvitations({});
    const rePromptInvitation = useContext(RePromptOrganizationInvitationContext);

    const invitation = clientInvitations?.[0];
    if (isLoadingClientInvitations || !invitation) {
        return null;
    }

    return (
        <LargeAlertPaper
            testID="client-invitation-alert"
            icon="AlertTriangle"
            title={intl('header')}
            message={intl('content', {
                organizationName: invitation.organization.metadata.name,
                profileName: getName({
                    firstName: invitation.clientFirstName,
                    lastName: invitation.clientLastName,
                }),
            })}
            actionItems={[
                {
                    testID: 'respond-to-client-invitation-button',
                    title: intl('actionText'),
                    onPress: rePromptInvitation,
                    icon: 'Settings',
                },
            ]}
        />
    );
};

export default React.memo(ClientInvitationAlert);
